import { Component, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'kve-banner-layout-templates',
  templateUrl: './banner-layout-templates.component.html',
  styleUrls: ['./banner-layout-templates.component.scss']
})
export class BannerLayoutTemplatesComponent implements OnInit {
  @Input() isCreate:boolean;

  @Output() pickLayout:EventEmitter<any> = new EventEmitter<any>();

  constructor(private el:ElementRef<HTMLElement>) { }

  ngOnInit(): void {
    if(this.isCreate != undefined && this.isCreate == false){
      let inputCells = this.el.nativeElement.querySelectorAll('.input-cell');
      inputCells.forEach((element:HTMLElement) => {
        element.classList.add("column");
      })
    }
  }

  selectLayout(layoutClass:string){
    this.pickLayout.emit(layoutClass)
  }

}
